import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';

import { getColor } from 'common/constants/_colors';

export const StyledIcon = styled(Icon)`
  padding-right: ${SPACES.small};
  :hover {
    cursor: pointer;
    color: ${getColor('chambray')} !important;
  }
`;

const getHoverBackgroundColor = props => {
  if (!props.disabled) {
    return '#d8deea';
  }
  if (props.bgcolor) {
    return '#F6F7FF';
  }
  return 'white';
};

export const StyledButton = styled(Flex)`
  background-color: ${props => (props.bgcolor ? '#F6F7FF' : 'white')};
  color: '#3B5998';
  border: 1px solid #d8deea !important;
  min-width: 65px;
  min-height: 30px;
  padding: 0 0.7rem;
  border-radius: 4px;
  transition: 0.3s;
  :hover {
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    background-color: ${props => getHoverBackgroundColor(props)};

    border-color: black;
    opacity: 1;
  }
  justify-content: center;
  color: #3b5998;
`;
